module.exports = __webpack_public_path__ + "img/image (135).5e50ac78.jpg";